import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button, Dropdown, Skeleton } from 'antd';
import { FormattedMessage } from 'react-intl';
import { User, Moon, Sun, Settings, LogOut } from 'react-feather';

import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';

import darkVars from '@/dark.json';
import lightVars from '@/light.json';

import './style.less';
import { authOperations } from '@/state/ducks/auth';
import AppHeaderButton from '@/components/_common/AppHeaderButton';
import { getUserFromLocalStorage } from '@/utils/user';
import { useEmployeeInfo } from '@/core/domain/enterprise/Employees/Employees.hooks';
import { UserAvatar } from '@/components/_common';
import { useColorScheme } from '@/contexts/ColorSchemeContextProvider';
import { useDisclosure } from '@/hooks';
import AboutThePlatformModal from '../AboutThePlatformModal';
import { useQueryClient } from 'react-query';

const menuTheme = {
  dark: {
    icon: <Sun />,
    label: 'layout.appBar.userDropdown.lightMode',
  },
  light: {
    icon: <Moon />,
    label: 'layout.appBar.userDropdown.nightMode',
  },
};

const DropdownOverlay = () => {
  const dispatch = useDispatch();
  const [colorScheme, setColorScheme] = useColorScheme();

  const queryClient = useQueryClient();
  const isDarkTheme = colorScheme === 'dark';

  const { employeeId, userEmail } = getUserFromLocalStorage();
  const { data, isLoading } = useEmployeeInfo(Number(employeeId));

  const [modalAbout, modalAboutAction] = useDisclosure();

  const handleDarkModeClick = () => {
    let vars = !isDarkTheme ? darkVars : lightVars;
    vars = { ...vars };

    setColorScheme(colorScheme === 'light' ? 'dark' : 'light');

    try {
      window.less.modifyVars({ ...vars });
    } catch (error) {
      console.error('LESS ERROR:', error); // eslint-disable-line
    }
  };

  const handleLogoutClick = () => {
    queryClient.clear();
    dispatch(authOperations.handleLogout());
  };

  return (
    <div className="overlay-wrapper">
      <div className="user-info">
        <Skeleton avatar loading={isLoading} paragraph={{ rows: 0 }} active>
          <div className="avatar">
            <UserAvatar gender={data?.gender} picture={data?.photo} size={40} />
          </div>

          <div className="info">
            <p className="name">{data?.name}</p>
            <p className="email">{userEmail}</p>
          </div>
        </Skeleton>
      </div>

      <div className="menu">
        <button type="button" className="item" onClick={handleDarkModeClick}>
          <div className="icon">
            <AntdFeatherIcon icon={menuTheme[colorScheme].icon} />
          </div>
          <span className="label">
            <FormattedMessage id={menuTheme[colorScheme].label} />
          </span>
        </button>

        <Link to="/app/configProfile/account">
          <div className="item">
            <div className="icon">
              <AntdFeatherIcon icon={<Settings />} />
            </div>
            <span className="label">Configurações de Perfil</span>
          </div>
        </Link>

        <button
          type="button"
          className="item logout"
          onClick={handleLogoutClick}
        >
          <div className="icon">
            <AntdFeatherIcon icon={<LogOut />} />
          </div>
          <div className="label">
            <FormattedMessage id="layout.appBar.userDropdown.logout" />
          </div>
        </button>
      </div>
      <div className="about">
        <Button
          type="link"
          onClick={modalAboutAction.open}
          style={{ padding: 0, margin: 0 }}
        >
          <FormattedMessage id="layout.appBar.userDropdown.about" />
        </Button>

        <Button
          type="link"
          onClick={() => window.open('/privacyPolicy', '_blank')}
          style={{ padding: 0, margin: 0 }}
        >
          <FormattedMessage id="layout.appBar.userDropdown.privacy" />
        </Button>
      </div>

      <AboutThePlatformModal
        open={modalAbout}
        onCancel={modalAboutAction.close}
      />
    </div>
  );
};

const UserDropdownMenu = () => (
  <Dropdown
    className="user-dropdown"
    placement="bottomRight"
    overlay={<DropdownOverlay />}
  >
    <AppHeaderButton icon={<User />} />
  </Dropdown>
);

export default UserDropdownMenu;
